// components/Footer.jsx
import React from "react";

export default function Footer() {
    return (
        <>
            <h2>©2077 Naitomea S.A., made with <span className="material-symbols-outlined">favorite</span></h2>
        </>
    );
}